export default {
	details: 'details',
};
